export const tinMask = 'AA-AAAAAAA';
export const einMask = '00-0000000';
